import type { UserMiniEntity } from "@/features/user/domain/entities/UserMiniEntity";

export class RevelationMiniEntity {
  couponId?: number;
  user?: UserMiniEntity;
  revelationDate?: string;
}